import React from 'react'

import { bootstrap } from '@bootstrap/bootstrap'
import Root from '@customer-complaints/Root'
import '@customer-complaints/index.css'
import { createRoot } from 'react-dom/client'

bootstrap({
  analytics: {
    google: {
      initialDataLayer: {
        pageType: 'complaints',
        store: import.meta.env.PUBLIC_STORE,
        currency: 'EUR',
        internalTraffic: document.cookie.includes('fondof_internal=true'),
        customerComplaintsVersion: import.meta.env.PUBLIC_RELEASE_VERSION,
      },
    },
  },
})

const container = document.getElementById('root')
if (container) {
  const root = createRoot(container)
  root.render(
    <React.StrictMode>
      <Root />
    </React.StrictMode>
  )
}
